// extracted by mini-css-extract-plugin
export default {"content":"CookieModal_content__DhnEB","header":"CookieModal_header__gTPvX"};